/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dataExportsListForOrg } from "../funcs/dataExportsListForOrg.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDataExportsForOrgResult } from "../models/components/listdataexportsfororgresult.js";
import {
  ListDataExportsForOrgRequest,
  ListDataExportsForOrgSecurity,
} from "../models/operations/listdataexportsfororg.js";
import { unwrapAsync } from "../types/fp.js";
export type ListDataExportsForOrgQueryData = ListDataExportsForOrgResult;

export function prefetchListDataExportsForOrg(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDataExportsForOrgRequest | undefined,
  security?: ListDataExportsForOrgSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListDataExportsForOrgQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListDataExportsForOrgQuery(
  client$: GramCore,
  request?: ListDataExportsForOrgRequest | undefined,
  security?: ListDataExportsForOrgSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListDataExportsForOrgQueryData>;
} {
  return {
    queryKey: queryKeyListDataExportsForOrg({
      gramSession: request?.gramSession,
    }),
    queryFn: async function listDataExportsForOrgQueryFn(
      ctx,
    ): Promise<ListDataExportsForOrgQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(dataExportsListForOrg(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListDataExportsForOrg(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "dataExports", "listForOrg", parameters];
}
